import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ConsultantSelectionModal = ({ show, handleClose, consultants, farmerId, handleAssign }) => {
  const [selectedConsultantId, setSelectedConsultantId] = useState("");

  const handleSubmit = () => {
    // Create form data for assigning the consultant
    const formData = {
      farmerId: farmerId,
      consultantId: selectedConsultantId,
    };
    // Call the function to handle the assignment
    handleAssign(formData);
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Select a Consultant</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="consultantSelect">
            <Form.Label>Select Consultant</Form.Label>
            <Form.Control
              as="select"
              value={selectedConsultantId}
              onChange={(e) => setSelectedConsultantId(e.target.value)}
            >
              <option value="">Choose...</option>
              {consultants.map((consultant) => (
                <option key={consultant.user_id} value={consultant.user_id}>
                  {consultant.user_name} - {consultant.distance} away
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button 
        className="reject-button" 
        style={{ width: "10vw" }}
        variant="secondary" onClick={handleClose}>
          Close
        </Button>
        
        <Button
        className="button" 
        style={{  color: "white", width: "15vw" }}
         variant="primary" onClick={handleSubmit} disabled={!selectedConsultantId}>
          Assign Consultant
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConsultantSelectionModal;
